import { useTheme } from '@emotion/react';
import React from 'react';

import { Text } from '~/components/blocks';
import { TextSpan } from '~/components/blocks/TextSpan';
import { OrganizationNotificationFragment } from '~/graphql/generated/graphql';
import { splitText } from '~/utils/split_text';

type Props = {
  notification: OrganizationNotificationFragment;
};

// api/config/locales/ja.yml の canceled_uber_delivery_without_return_pin_code が本文に入れる文字列
const PIN_CODE_UNAVAILABLE_KEYWORD = '取得失敗';

const getReturnPinCode = (meta: unknown): string | null => {
  if (typeof meta !== 'object' || meta === null) return null;

  const value = (meta as Record<string, unknown>).return_pin_code;

  return typeof value === 'string' && value !== '' ? value : null;
};

const ContentText = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme();

  return (
    <Text
      color="white"
      size="xs"
      fontWeight="bold"
      marginLeft={theme.space.m}
      whiteSpace="pre-wrap"
    >
      {children}
    </Text>
  );
};

export const NotificationContentText = React.memo((props: Props) => {
  const { notification } = props;
  const returnPinCode = getReturnPinCode(notification.meta);
  const { before, keyword, after } = splitText(
    notification.content,
    returnPinCode ?? PIN_CODE_UNAVAILABLE_KEYWORD,
  );

  if (keyword === '') return <ContentText>{notification.content}</ContentText>;

  return (
    <ContentText>
      {before}
      <TextSpan size="m" text={keyword} />
      {after}
    </ContentText>
  );
});

NotificationContentText.displayName = 'NotificationContentText';
